import { render, staticRenderFns } from "./OctMenuItem.vue?vue&type=template&id=fdd8b030&scoped=true&"
import script from "./OctMenuItem.vue?vue&type=script&lang=js&"
export * from "./OctMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./OctMenuItem.vue?vue&type=style&index=0&id=fdd8b030&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd8b030",
  null
  
)

export default component.exports